import { SxProps } from "@mui/material";
import { ChangeEvent, useEffect, useState } from "react";
import { GroupedTableColumn } from "./GroupedTable";
import GroupedTableColumns from "./GroupedTableColumns";
import GroupedTableRowComponent from "./GroupedTableRowComponent";
import { CheckboxPadded, TableCellFixedWidth } from "./styled";

interface Props {
  columns: GroupedTableColumn[];
  item: any;
  sx?: SxProps;
  selectItem: (item: any, checkBoxSelected: boolean) => void;
  selectedItems: any[];
  onClickRow?: (row: any) => void;
  customColor?: string;
  disableSelectItems: boolean;
  hideCheckboxes?: boolean;
  buildUrl?: (item: any) => string;
}

export const GroupedTableRow = ({
  columns,
  item,
  sx,
  selectItem,
  selectedItems,
  onClickRow,
  customColor,
  disableSelectItems,
  hideCheckboxes,
  buildUrl,
}: Props) => {
  const [isSelected, setIsSelected] = useState<boolean>(false);

  const handleChange = (event: ChangeEvent<HTMLInputElement>, item: any) => {
    selectItem(item, event.target.checked);
  };

  const openRow = () => {
    onClickRow && item.rowVariant !== "disabled" && onClickRow(item);
  };

  useEffect(() => {
    setIsSelected(
      !!selectedItems.find((selectedItem) => selectedItem.id === item.id),
    );
  }, [selectedItems, item]);

  return (
    <GroupedTableRowComponent
      to={item?.url || (buildUrl && buildUrl(item))}
      rowVariant={item?.rowVariant}
      customColor={customColor}
      sx={sx}
    >
      <>
        {!disableSelectItems && (
          <TableCellFixedWidth>
            {!hideCheckboxes && (
              <CheckboxPadded
                onClick={(e) => e.stopPropagation()}
                {...(item.rowVariant !== "disabled" && {
                  onChange: (e) => handleChange(e, item),
                })}
                checked={isSelected}
              />
            )}
          </TableCellFixedWidth>
        )}
        <GroupedTableColumns
          columns={columns}
          item={item}
          onClick={openRow}
          disableSelectItems={disableSelectItems}
        />
      </>
    </GroupedTableRowComponent>
  );
};
